import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fd58962"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM7.69444 12H31.3056C31.7222 12 32 12.2778 32 12.6944V15.75L19.5 21.1667L7 15.75V12.6944C7 12.2778 7.27778 12 7.69444 12ZM19.0833 23.1111C19.2222 23.25 19.3611 23.25 19.5 23.25C19.6389 23.25 19.7778 23.25 19.9167 23.1111L32 17.9722V27.8333C32 28.25 31.7222 28.5278 31.3056 28.5278H7.69444C7.27778 28.5278 7 28.25 7 27.8333V17.9722L19.0833 23.1111Z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-email",
    width: _ctx.px,
    height: _ctx.px,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}